import { FormControl, FormGroup, Validators } from '@angular/forms';
import { KraftfahrzeugType } from '@base/backend';

export function createKaufpreisProductForm(): FormGroup<KaufpreisProductFormModel> {
  return new FormGroup<KaufpreisProductFormModel>({
    servoKaufpreisKaskoKraftfahrzeugType: new FormControl<KraftfahrzeugType | null>(KraftfahrzeugType.Pkw, [Validators.required]),
    brand: new FormControl<string | null>(null, [Validators.required]),
    model: new FormControl<string | null>(null, [Validators.required]),
    fin: new FormControl<string | null>(null, [Validators.required]),
    dateOfFirstRegistration: new FormControl<string | null>(null, [Validators.required]),
    mileage: new FormControl<number | null>(null, [Validators.required])
  });
}

export interface KaufpreisProductFormModel {
  servoKaufpreisKaskoKraftfahrzeugType: FormControl<KraftfahrzeugType | null>;
  brand: FormControl<string | null>;
  model: FormControl<string | null>;
  fin: FormControl<string | null>;
  dateOfFirstRegistration: FormControl<string | null>;
  mileage: FormControl<number | null>;
}
